import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-enlarge",
  "use": "icon-icon-enlarge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-enlarge\"><defs><style type=\"text/css\"></style></defs><path d=\"M764.416 701.44c58.88-72.704 93.696-165.376 93.696-266.24 0-235.008-190.464-425.472-425.472-425.472s-425.472 190.464-425.472 425.472c0 235.008 190.464 425.472 425.472 425.472 116.224 0 221.696-46.592 298.496-122.368l247.296 274.432 36.864-33.28-250.88-278.016z m-331.776 109.568c-207.872 0-375.808-168.448-375.808-375.808s170.496-375.808 375.808-375.808c207.872 0 375.808 168.448 375.808 375.808s-167.936 375.808-375.808 375.808z\" fill=\"\" p-id=\"2652\" /><path d=\"M457.728 249.856h-49.664v160.768h-160.768v49.152h160.768v160.768h49.664v-160.768h160.768v-49.152h-160.768z\" fill=\"\" p-id=\"2653\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-enlarge.svg
// module id = DhAu
// module chunks = 1